import { HttpClient } from "@/app/api/HttpClient"
import { API_PREFIX_VIDEO_PATH } from "@/constants/prefix-path-api"
import { FilterSearchParams } from "@/types/types"
import { message } from "antd"

export interface VideoAttributes {
  title: string
  youtubeUrl: string
  order?: number
  publishedAt?: string | null
  categories?: { data: Array<{ id: number }> }
}

export const fetchVideos = async (
  searchTerms: { [key: string]: string } = {},
  publicationState: string = "live",
) => {
  const params: FilterSearchParams = {
    sort: "createdAt:desc",
    filters: {},
    pagination: {
      pageSize: "20",
    },
    publicationState,
  }

  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "populate") {
      params.populate = value
    } else if (key === "sort") {
      if (value) params.sort = value
    } else if (key === "locale") {
      params.locale = value
    } else if (key === "publishedAtNull") {
      params.filters["publishedAt"] = { $null: value === "true" }
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value) {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })
  
  try {
    const response = await HttpClient.get(`${API_PREFIX_VIDEO_PATH}`, { params,skipDomainFilter:true })
    return response
  } catch (error) {
    message.error("Không thể lấy video. Vui lòng thử lại.")
  }
}

export const fetchVideoById = async (id: string) => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_VIDEO_PATH}/${id}?populate=*`,{skipDomainFilter:true})
    return response
  } catch (error) {
    message.error("Không thể lấy video. Vui lòng thử lại.")
  }
}

export const getVideoById = async (id: number) => {
  return await HttpClient.get(`${API_PREFIX_VIDEO_PATH}/${id}?populate=*`,{skipDomainFilter:true})
}

export const getVideoDetail = async (id: number) => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_VIDEO_PATH}/${id}?populate=*`,{skipDomainFilter:true})
    return response
  } catch (error) {
    message.error("Không thể lấy chi tiết video. Vui lòng thử lại.")
  }
}

export const updateVideo = async (id: string, updatedData: VideoAttributes) => {
  return await HttpClient.put(`${API_PREFIX_VIDEO_PATH}/${id}`, { data: updatedData },{skipDomainFilter:true})
}

export const createVideo = async (data: VideoAttributes) => {
  return await HttpClient.post(`${API_PREFIX_VIDEO_PATH}`, { data },{skipDomainFilter:true})
}

export const deleteVideo = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_VIDEO_PATH}/${id}`,{skipDomainFilter:true})
}

